module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPoAAAASCAYAAABy+8PSAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAALZJREFUeNrs28EJwjAUgOFWvIsTiLdmCnETR3AVN+gIHUE38NarI7iBvkAEIROk/T54NNCeAj+00PTDMHw6YNE25XqLOZd52BZoWtXzttwY53l+5kVKaYrLyV5Bs6qe+/Lqnqu/l4cuMQd7Bc2qeu59o8N6vtEBoQNCB4QOCB0QOiB0QOiA0GFVoeef4Pcxx86hFmhd1fMv9PwT/DvmFevJPkHTqp4daoHl+e/5GrNzqAVW4CvAABg+MTevjwCEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/front/ARAD1SN.png
// module id = mqyS
// module chunks = 0